import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080' });

const listingService = {
  createListing: async (data) => {
    const response = await api.post('/api/listings', data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  },

  uploadImages: async (listingId, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('images', file));
    const response = await api.post(`/api/listings/${listingId}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  getMyListings: async (uid) => {
    const response = await api.get('/api/listings', { params: { uid } });
    return response.data;
  },

  updateListing: async (id, data) => {
    const response = await api.put(`/api/listings/${id}`, data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  },

  deleteListing: async (id) => {
    await api.delete(`/api/listings/${id}`);
  },
};

export default listingService;
